import type { ReactNode } from "react";

/**
 * A surface card — the `fawkes-form-card` vocabulary from docs/ui-conventions.md.
 *
 * `className` is appended, never replaced, so a screen can scope its own rules (or set a themed
 * custom property) on the card without every other consumer changing.
 */
export function FormCard({ children, className }: { children: ReactNode; className?: string }) {
  return <section className={className ? `fui-card ${className}` : "fui-card"}>{children}</section>;
}
